export const ESPN_HERO_LALIGA_PLAYER_IMAGES: Record<string, Record<string, string[]>> = {
  alaves: {
    'antonio-blanco': [
      'antonio-blanco-001.png',
      'antonio-blanco-002.png'
      /*  'antonio-blanco-003.png',
      'antonio-blanco-004.png',
      'antonio-blanco-005.png',
      'antonio-blanco-006.png',
      'antonio-blanco-007.png',
      'antonio-blanco-008.png' */
    ],
    'carlos-vicente': [
      'carlos-vicente-001.png'
      /*  'carlos-vicente-002.png',
      'carlos-vicente-003.png',
      'carlos-vicente-004.png' */
    ],
    'lucas-boye': [
      'lucas-boye-001.png',
      'lucas-boye-002.png'
      /*    'lucas-boye-003.png',
      'lucas-boye-004.png',
      'lucas-boye-005.png',
      'lucas-boye-006.png' */
    ]
    /*    'mariano-diaz': ['mariano-diaz-001.png', 'mariano-diaz-002.png', 'mariano-diaz-003.png', 'mariano-diaz-004.png'],
    'nahuel-tenaglia': [
      'nahuel-tenaglia-001.png',
      'nahuel-tenaglia-002.png',
      'nahuel-tenaglia-003.png',
      'nahuel-tenaglia-004.png'
    ] */
  },
  'athletic-club': {
    'aymeric-laporte': [
      'aymeric-laporte-001.png'
      /*   'aymeric-laporte-002.png',
      'aymeric-laporte-003.png',
      'aymeric-laporte-004.png',
      'aymeric-laporte-005.png' */
    ],
    'alex-berenguer': [
      'alex-berenguer-001.png'
      /*  'alex-berenguer-002.png',
      'alex-berenguer-003.png',
      'alex-berenguer-004.png',
      'alex-berenguer-005.png',
      'alex-berenguer-006.png' */
    ],
    'inaki-williams': [
      'inaki-williams-001.png',
      'inaki-williams-002.png'
      /*  'inaki-williams-003.png',
      'inaki-williams-004.png',
      'inaki-williams-005.png',
      'inaki-williams-006.png',
      'inaki-williams-007.png',
      'inaki-williams-008.png' */
    ],
    'nico-williams': [
      'nico-williams-001.png',
      'nico-williams-002.png'
      /*    'nico-williams-003.png',
      'nico-williams-004.png' */
    ],
    'unai-gomez': [
      'unai-gomez-001.png',
      'unai-gomez-002.png',
      /*     'unai-gomez-003.png',
      'unai-gomez-004.png', */
      'unai-gomez-005.png',
      'unai-gomez-006.png'
    ]
  },
  'atletico-madrid': {
    /*     'thiago-almada': [
      'thiago-almada-001.png',
      'thiago-almada-002.png',
      'thiago-almada-003.png',
      'thiago-almada-004.png',
      'thiago-almada-005.png',
      'thiago-almada-006.png',
      'thiago-almada-007.png',
      'thiago-almada-008.png'
    ],
    'jose-maria-gimenez': [
      'jose-maria-gimenez-001.png',
      'jose-maria-gimenez-002.png',
      'jose-maria-gimenez-003.png',
      'jose-maria-gimenez-004.png',
      'jose-maria-gimenez-005.png',
      'jose-maria-gimenez-006.png'
    ],
    'giuliano-simeone': [
      'giuliano-simeone-001.png',
      'giuliano-simeone-002.png',
      'giuliano-simeone-003.png',
      'giuliano-simeone-004.png',
      'giuliano-simeone-005.png',
      'giuliano-simeone-006.png'
    ], */
    'antoine-griezmann': ['antoine-griezmann-001.png', 'antoine-griezmann-002.png'],
    'julian-alvarez': ['julian-alvarez-001.png', 'julian-alvarez-002.png'],
    'alexander-sorloth': ['alexander-sorloth-001.png']
  },
  barcelona: {
    /*     'ronald-araujo': [
      'ronald-araujo-001.png',
      'ronald-araujo-002.png',
      'ronald-araujo-003.png',
      'ronald-araujo-004.png',
      'ronald-araujo-005.png',
      'ronald-araujo-006.png'
    ], */
    'robert-lewandowski': [
      'robert-lewandowski-001.png'
      /*     'robert-lewandowski-002.png',
      'robert-lewandowski-003.png',
      'robert-lewandowski-004.png',
      'robert-lewandowski-005.png' */
    ],
    'pedro-gonzalez': [
      'pedro-gonzalez-001.png'
      /*     'pedro-gonzalez-002.png',
      'pedro-gonzalez-003.png',
      'pedro-gonzalez-004.png' */
    ],
    'raphael-dias-belloli': [
      'raphael-dias-belloli-001.png'
      /*     'raphael-dias-belloli-002.png',
      'raphael-dias-belloli-003.png',
      'raphael-dias-belloli-004.png' */
    ],
    'lamine-yamal': [
      'lamine-yamal-001.png'
      /* 'lamine-yamal-002.png',
      'lamine-yamal-003.png',
      'lamine-yamal-004.png',
      'lamine-yamal-005.png' */
    ]
  },
  celta: {
    'borja-iglesias': ['borja-iglesias-001.png', 'borja-iglesias-002.png'],
    'iago-aspas': ['iago-aspas-001.png'],
    'marcos-alonso': ['marcos-alonso--001.png'],
    mingueza: ['mingueza-001.png', 'mingueza-002.png']
  },
  elche: {
    'andre-silva': ['andre-silva-001.png', 'andre-silva-002.png'],
    dituro: ['dituro-001.png', 'dituro-002.png'],
    'fernando-redondo': ['fernando-redondo-012.png', 'fernando-redondo-013.png'],
    'rafa-mir': ['rafa-mir-001.png', 'rafa-mir-002.png']
  },
  espanyol: {
    'javi-puado': ['javi-puado-001.png', 'javi-puado-002.png'],
    'kike-garcia': ['kike-garcia-001.png', 'kike-garcia-002.png'],
    'leandro-cabrera': ['leandro-cabrera-001.png', 'leandro-cabrera-002.png'],
    'pol-lozano': ['pol-lozano-001.png', 'pol-lozano-002.png']
  },
  getafe: {
    'adrian-liso': ['adrian-liso-008.png', 'adrian-liso-011.png'],
    arambarri: ['arambarri-001.png', 'arambarri-002.png'],
    'domingos-duarte': ['domingos-duarte-001.png', 'domingos-duarte-002.png'],
    'juan-antonio-iglesias': ['juan-antonio-iglesias-001.png', 'juan-antonio-iglesias-002.png'],
    kiko: ['kiko-001.png', 'kiko-002.png'],
    mayoral: ['mayoral-001.png', 'mayoral-002.png']
  },
  girona: {
    asprilla: ['asprilla-001.png', 'asprilla-002.png'],
    blind: ['blind-001.png', 'blind-002.png'],
    stuani: ['stuani-001.png', 'stuani-002.png'],
    'thomas-lemar': ['thomas-lemar-001.png', 'thomas-lemar-002.png'],
    'viktor-tsygankov': ['viktor-tsygankov-001.png', 'viktor-tsygankov-002.png'],
    'vitor-reis': ['vitor-reis-001.png', 'vitor-reis-002.png']
  },
  levante: {
    'carlos-alvarez': ['carlos-alvarez-001.png', 'carlos-alvarez-002.png'],
    'ivan-romero': ['ivan-romero-001.png', 'ivan-romero-002.png'],
    'matias-moreno': ['matias-moreno-001.png', 'matias-moreno-002.png'],
    maturro: ['maturro-001.png', 'maturro-002.png'],
    'pablo-martinez': ['pablo-martinez-001.png', 'pablo-martinez-002.png']
  },
  mallorca: {
    maffeo: ['maffeo-001.png', 'maffeo-002.png'],
    mojica: ['mojica-001.png', 'mojica-002.png'],
    muriqi: ['muriqi-001.png', 'muriqi-002.png']
  },
  osasuna: {
    boyomo: ['boyomo-001.png', 'boyomo-002.png'],
    budimir: ['budimir-001.png', 'budimir-002.png'],
    oroz: ['oroz-001.png', 'oroz-002.png']
  },
  'rayo-vallecano': {
    'alvaro-garcia': ['alvaro-garcia-001.png', 'alvaro-garcia-002.png'],
    andrei: ['andrei-001.png', 'andrei-002.png'],
    batalla: ['batalla-001.png', 'batalla-002.png'],
    'de-frutos': ['de-frutos-001.png', 'de-frutos-002.png'],
    'isi-palazon': ['isi-palazon-001.png'],
    'luiz-felipe': ['luiz-felipe-001.png', 'luiz-felipe-002.png'],
    trejo: ['trejo-001.png', 'trejo-002.png'],
    'unai-lopez': ['unai-lopez-001.png']
  },
  'real-betis': {
    antony: ['antony-001.png'],
    'cucho-hernandez': ['cucho-hernandez-001.png'],
    'giovani-lo-celso': ['giovani-lo-celso-001.png'],
    natan: ['natan-001.png'],
    'nelson-deossa': ['nelson-deossa-001.png'],
    'pablo-fornals': ['pablo-fornals-002.png'],
    'valentin-gomez': ['valentin-gomez-002.png', 'valentin-gomez-004.png']
  },
  'real-madrid': {
    'federico-valverde': ['federico-valverde-001.png'],
    'franco-mastantuono': ['franco-mastantuono-001.png', 'franco-mastantuono-002.png'],
    'jude-bellingham': ['jude-bellingham-001.png', 'jude-bellingham-002.png'],
    'kylian-mbappe': ['kylian-mbappe-001.png', 'kylian-mbappe-002.png'],
    'vini-jrs': ['vini-jrs-001.png', 'vini-jrs-002.png']
  },
  'real-oviedo': {
    'david-costas': ['david-costas-001.png', 'david-costas-002.png'],
    'fede-vinas': ['fede-vinas-001.png'],
    'haissem-hassan': ['haissem-hassan-001.png'],
    'ilyas-chaira': ['ilyas-chaira-001.png', 'ilyas-chaira-002.png'],
    'nacho-vidal': ['nacho-vidal-001.png', 'nacho-vidal-002.png'],
    'santiago-cazorla': ['santiago-cazorla-001.png', 'santiago-cazorla-002.png'],
    'santiago-colombatto': ['santiago-colombatto-001.png', 'santiago-colombatto-002.png']
  },
  'real-sociedad': {
    aramburu: ['aramburu-001.png'],
    'carlos-soler': ['carlos-soler-001.png', 'carlos-soler-002.png'],
    'gonzalo-guedes': ['gonzalo-guedes-001.png'],
    'jon-gorrotxategi': ['jon-gorrotxategi-001.png'],
    'mikel-oyarzabal': ['mikel-oyarzabal-001.png', 'mikel-oyarzabal-002.png'],
    'takefusa-kubo': ['takefusa-kubo-001.png', 'takefusa-kubo-002.png']
  },
  sevilla: {
    'alexis-sanchez': ['alexis-sanchez-001.png', 'alexis-sanchez-002.png', 'alexis-sanchez-003.png'],
    'gabriel-suazo': ['gabriel-suazo-001.png', 'gabriel-suazo-002.png'],
    'januzaj-adnan': ['januzaj-adnan-001.png', 'januzaj-adnan-002.png']
  },
  valencia: {
    'andre-almeida': ['andre-almeida-001.png', 'andre-almeida-002.png'],
    'arnaut-danjuma': ['arnaut-danjuma-001.png', 'arnaut-danjuma-002.png'],
    'diego-lopez': ['diego-lopez-001.png', 'diego-lopez-002.png'],
    gaya: ['gaya-001.png', 'gaya-002.png'],
    'hugo-duro': ['hugo-duro-001.png', 'hugo-duro-002.png'],
    'javi-guerra': ['javi-guerra-001.png', 'javi-guerra-002.png'],
    'lucas-beltran': ['lucas-beltran-001.png', 'lucas-beltran-002.png']
  },
  villarreal: {
    foyth: ['foyth-001.png'],
    mikautadze: ['mikautadze-001.png'],
    moreno: ['moreno-001.png'],
    parejo: ['parejo-001.png'],
    partey: ['partey-001.png', 'partey-002.png'],
    pepe: ['pepe-001.png']
  }
};
